/* Collection & search filtering, sorting, load more and grid density. */
(() => {
  const theme = window.theme;
  const root = document.querySelector('[data-facets]');
  if (!root) return;
  const sectionId = root.dataset.sectionId;
  const cache = new Map();
  let controller;

  const getForm = () => document.querySelector('[data-facets-form]');

  const queryFromForm = () => {
    const form = getForm();
    const params = new URLSearchParams();
    if (!form) return params;
    for (const [key, value] of new FormData(form)) {
      if (value === '') continue;
      if (key === 'sort_by' && value === form.dataset.defaultSort) continue;
      params.append(key, value);
    }
    // Keep the search term on the search page.
    const q = new URLSearchParams(location.search).get('q');
    if (q && !params.has('q')) params.set('q', q);
    const type = new URLSearchParams(location.search).get('type');
    if (type && !params.has('type')) params.set('type', type);
    return params;
  };

  const openGroups = () => [...document.querySelectorAll('[data-facets-body] details[open]')].map((d) => d.id);

  async function render(url, { push = true } = {}) {
    const target = new URL(url, location.origin);
    target.searchParams.delete('page');
    const fetchUrl = new URL(target);
    fetchUrl.searchParams.set('section_id', sectionId);
    root.classList.add('is-loading');
    controller?.abort();
    controller = new AbortController();
    try {
      let html = cache.get(fetchUrl.href);
      if (!html) {
        const res = await fetch(fetchUrl, { signal: controller.signal });
        html = await res.text();
        cache.set(fetchUrl.href, html);
      }
      const doc = theme.parseHTML(html);
      const keepOpen = openGroups();

      // Results (grid, active filters, pagination)
      const results = doc.querySelector('[data-facets-results]');
      document.querySelector('[data-facets-results]')?.replaceWith(results);

      // Filter groups with updated counts — preserve which groups are expanded.
      const body = doc.querySelector('[data-facets-body]');
      if (body) {
        body.querySelectorAll('details').forEach((d) => { d.open = keepOpen.includes(d.id); });
        document.querySelector('[data-facets-body]')?.replaceWith(body);
      }

      ['[data-facets-results-count]', '[data-facets-count]', '[data-facets-total]'].forEach((sel) => {
        const fresh = doc.querySelector(sel);
        const current = document.querySelector(sel);
        if (fresh && current) {
          current.innerHTML = fresh.innerHTML;
          current.hidden = fresh.hidden;
        }
      });

      const sort = doc.querySelector('[data-sort]');
      const currentSort = document.querySelector('[data-sort]');
      if (sort && currentSort) currentSort.value = sort.value;

      if (push) history.pushState({ facets: true }, '', target.pathname + target.search);
      theme.observeReveal?.(document.querySelector('[data-facets-results]'));
    } catch (e) {
      if (e.name !== 'AbortError') location.href = target.href;
    } finally {
      root.classList.remove('is-loading');
    }
  }

  let debounce;
  document.addEventListener('change', (event) => {
    if (event.target.closest('[data-facets-form]')) {
      clearTimeout(debounce);
      const delay = event.target.type === 'number' ? 600 : 0;
      debounce = setTimeout(() => render(`${location.pathname}?${queryFromForm()}`), delay);
      return;
    }
    if (event.target.matches('[data-sort]')) {
      const radio = getForm()?.querySelector(`input[name="sort_by"][value="${CSS.escape(event.target.value)}"]`);
      if (radio) radio.checked = true;
      const params = queryFromForm();
      params.set('sort_by', event.target.value);
      render(`${location.pathname}?${params}`);
    }
  });

  document.addEventListener('submit', (event) => {
    if (!event.target.matches('[data-facets-form]')) return;
    event.preventDefault();
    theme.closeDialog(document.getElementById('FacetsDrawer'));
  });

  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-facet-link]');
    if (link) {
      event.preventDefault();
      render(link.href);
      return;
    }

    const more = event.target.closest('[data-load-more]');
    if (more) {
      event.preventDefault();
      loadMore(more);
      return;
    }

    const gridBtn = event.target.closest('[data-grid]');
    if (gridBtn) setDensity(gridBtn.dataset.grid);
  });

  async function loadMore(button) {
    button.classList.add('is-loading');
    const url = new URL(button.href);
    url.searchParams.set('section_id', sectionId);
    try {
      const doc = theme.parseHTML(await (await fetch(url)).text());
      const grid = document.querySelector('[data-product-grid]');
      const items = doc.querySelectorAll('[data-product-grid] > li');
      const first = items[0];
      items.forEach((li) => grid.append(li));
      document.querySelector('[data-load-more-wrap]')?.replaceWith(doc.querySelector('[data-load-more-wrap]') || '');
      theme.observeReveal?.(grid);
      first?.querySelector('a')?.focus({ preventScroll: true });
    } catch (e) {
      location.href = button.href;
    }
  }

  // Grid density (persisted per visitor)
  const KEY = 'blvck:grid';
  const setDensity = (mode) => {
    root.dataset.density = mode;
    document.querySelectorAll('[data-grid]').forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.grid === mode)));
    try { localStorage.setItem(KEY, mode); } catch (e) {}
  };
  let saved = 'more';
  try { saved = localStorage.getItem(KEY) || 'more'; } catch (e) {}
  setDensity(saved);

  addEventListener('popstate', () => render(location.href, { push: false }));
})();
